/*
======================================================
BYMOQA Liquid UI
Main Controller
======================================================
*/

document.addEventListener("DOMContentLoaded", () => {

    const header = document.getElementById("bymoqaHeader");

    if (!header) return;

    window.Bymoqa = {

        header,

        motion:{},
        light:{},
        scroll:{},
        search:{},
        material:{},
        effects:{},
        state:{}

    };

    function run(name, fn){

        if(typeof fn !== "function") return;

        try{

            console.log("Initializing:", name);

            fn(window.Bymoqa);

            console.log("✓", name);

        }catch(error){

            console.error("✗ " + name, error);

        }

    }

    run("Light", window.initBymoqaLight);
    run("Material", window.initBymoqaMaterial);
    run("Motion", window.initBymoqaMotion);
    run("Scroll", window.initBymoqaScroll);
    run("Search", window.initBymoqaSearch);
    run("State", window.initBymoqaState);
    run("Effects", window.initBymoqaEffects);

    /* ==========================================
       Dawn Drawer Bridge
    ========================================== */

    const menuButton =
        document.querySelector(".menu-trigger");

    const dawnSummary =
        document.querySelector("#Details-menu-drawer-container summary");

    if(menuButton && dawnSummary){

        menuButton.addEventListener("click",()=>{

            dawnSummary.click();

        });

    }



/* ==========================================
   Hero Header Dock
========================================== */


/* ==========================================
   Hero Header Dock
========================================== */

const main = document.getElementById("MainContent");
const isHome = main && main.dataset.template === "index";

if (isHome) {

    const hero = document.querySelector(".bymoqa-hero");

    if (hero) {

        const observer = new IntersectionObserver(

            ([entry]) => {

                if (entry.intersectionRatio > 0.35) {

                    header.classList.remove("docked");

                } else {

                    header.classList.add("docked");

                }

            },

            {
                threshold: [0, 0.35, 1]
            }

        );

        observer.observe(hero);

    }

}

});